(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["j-footer"] && !Shopify.designMode) return;
  try {
    
const footerQuery=window.matchMedia('(min-width:750px)');const updateFooter=()=>document.querySelectorAll('.j-footer details').forEach(d=>d.open=footerQuery.matches);updateFooter();footerQuery.addEventListener('change',updateFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["j-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('j-header'))customElements.define('j-header',class extends HTMLElement{
 connectedCallback(){
  if(this._events)return;
  this._events=new AbortController();
  const options={signal:this._events.signal},dialog=this.querySelector('dialog'),opener=this.querySelector('[data-open-menu]');
  this.querySelector('[data-open-cart]').addEventListener('click',event=>{const drawer=document.getElementById('cart-drawer');if(drawer?.open){event.preventDefault();drawer.open()}},options);
  document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(({cart,detail})=>{if(options.signal.aborted)return;this.updateCartCount(cart?.totalQuantity??detail?.itemCount??(cart===null?0:undefined))}).catch(()=>{})},options);
  document.addEventListener('j:cart-updated',event=>this.updateCartCount(event.detail?.itemCount),options);
  document.addEventListener('cart-section:restored',event=>{const drawer=document.getElementById('cart-drawer')||event.target,count=drawer?.querySelector('[data-cart-item-count]')?.dataset.cartItemCount;if(count!=null){this.updateCartCount(count);return}try{const payload=JSON.parse((drawer?.matches('cart-items-component')?drawer:drawer?.querySelector('cart-items-component'))?.getAttribute('view-event-payload')||'null');if(payload)this.updateCartCount(payload.cart?.totalQuantity??0)}catch{}},options);
  opener.addEventListener('click',()=>{if(dialog.open)return;dialog.showModal();opener.setAttribute('aria-expanded','true');this._overflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden'},options);
  this.querySelector('[data-close-menu]').addEventListener('click',()=>dialog.close(),options);
  dialog.addEventListener('close',()=>{opener.setAttribute('aria-expanded','false');document.documentElement.style.overflow=this._overflow??'';this._overflow=null},options);
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close()},options);
  dialog.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>dialog.close(),options));
 }
 updateCartCount(value){
  if(value==null||value==='')return;
  const count=Number(value);if(!Number.isInteger(count)||count<0)return;
  const link=this.querySelector('[data-open-cart]'),bubble=this.querySelector('[data-header-cart-count]');
  if(!link||!bubble)return;
  bubble.textContent=String(count);bubble.hidden=count===0;
  link.setAttribute('aria-label',`${link.dataset.cartLabel}. ${link.dataset.cartCountLabel}: ${count}`);
 }
 disconnectedCallback(){if(this._overflow!=null)document.documentElement.style.overflow=this._overflow;this._events?.abort();this._events=null}
});
(() => {
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const seen = new Set();
  let timer;
  const prefetch = anchor => {
    if (!anchor || seen.size >= 6 || anchor.download || anchor.target) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || url.search || url.hash || url.pathname === location.pathname) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+|products\/[^/]+)?$/i.test(url.pathname)) return;
    if (seen.has(url.href)) return;
    seen.add(url.href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    link.fetchPriority = 'low';
    document.head.append(link);
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(timer);
    const anchor = event.target.closest('a[href]');
    timer = setTimeout(() => prefetch(anchor), 80);
  }, {passive: true});
  document.addEventListener('pointerout', () => clearTimeout(timer), {passive: true});
  document.addEventListener('focusin', event => prefetch(event.target.closest('a[href]')));
  document.addEventListener('pointerdown', event => prefetch(event.target.closest('a[href]')), {passive: true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
